"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var prefixCls = 'dpl-load-view';
function Loading(props) {
  var visible = props.visible,
    bgcover = props.bgcover,
    className = props.className,
    style = props.style,
    size = props.size;
  var classes = (0, _classnames["default"])(prefixCls, className, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, "".concat(prefixCls, "-sm"), size === 'small'), "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-show"), visible), "".concat(prefixCls, "-bgcover"), !bgcover));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(prefixCls, "-progress-bar")
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "dpl-indicator"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    className: "dpl-indicator-circle1",
    cx: "50",
    cy: "50",
    r: "45",
    strokeWidth: "10"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "50",
    cy: "50",
    r: "45",
    className: "dpl-indicator-circle2",
    strokeWidth: "10",
    strokeLinecap: "round",
    strokeDasharray: "78 400",
    transform: "rotate(570 50 50)"
  }, /*#__PURE__*/_react["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;360 50 50;720 50 50",
    keyTimes: "0;0.5;1",
    dur: "2s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
Loading.propTypes = {
  visible: _propTypes["default"].bool
};
Loading.defaultProps = {
  visible: false
};
var _default = exports["default"] = Loading;